// SceneExtendPin — плашка «продлеваем сцену» над полем промпта.
//
// Продление у Gemini Omni (Original) устроено не как загрузка файла: Google
// дописывает хвост к СВОЕЙ предыдущей интеракции, поэтому в баре нечего
// показать слотом — источник это прошлая генерация, а не медиа. Плашка и есть
// весь UI: она объясняет, к чему приклеится результат, показывает арифметику
// длины (18 с + 6 с = 24 из 40) и даёт снять контекст крестиком.
//
// Источник живёт в sceneExtendTracker (липкий по модели, переживает ретрай).
// Тег в тело запроса подмешивает ApiClient — здесь только показ и отмена.
import { useEffect, useState } from 'react'

import { useGenerate } from '../../../context/GenerateContext'
import {
	clearSceneExtendSource,
	getSceneExtendSource,
	subscribeSceneExtend,
	type SceneExtendSource,
} from '../../../api/sceneExtendTracker'
import { Icon } from '../../../../public/icons/Icon.tsx'

export default function SceneExtendPin() {
	const { selectedModel, settings } = useGenerate()
	const [source, setSource] = useState<SceneExtendSource | null>(getSceneExtendSource())

	useEffect(() => subscribeSceneExtend(() => setSource(getSceneExtendSource())), [])

	// Смена карточки снимает контекст (см. sceneExtendTracker): продлевать
	// сцену Omni чем-то другим нельзя, и висящая плашка врала бы.
	useEffect(() => {
		const backend = selectedModel?.backendModel
		if (source && backend && backend !== source.modelId) clearSceneExtendSource()
	}, [selectedModel?.backendModel, source])

	if (!source || !selectedModel?.supportsSceneExtend) return null

	const added = Number(settings.duration) || 0
	const max = selectedModel.maxSceneSeconds ?? 40
	const total = source.sceneSeconds + added
	const over = total > max

	return (
		<div className={`scene-extend-pin${over ? ' scene-extend-pin--over' : ''}`}>
			<span className="scene-extend-pin__icon" aria-hidden="true">
				<Icon id="gen-add" size={14} />
			</span>
			<span className="scene-extend-pin__text">
				<b>Продлеваем сцену</b>
				<span className="scene-extend-pin__math">
					{source.sceneSeconds} с + {added} с = {total} с из {max}
				</span>
				{over && (
					<span className="scene-extend-pin__warn">
						Больше {max} с модель не умеет — уменьшите длительность.
					</span>
				)}
				{source.prompt && <span className="scene-extend-pin__src">«{source.prompt}»</span>}
			</span>
			<button
				type="button"
				className="scene-extend-pin__close"
				onClick={clearSceneExtendSource}
				aria-label="Не продлевать"
				title="Не продлевать — обычная генерация"
			>
				<Icon id="gen-close" size={12} />
			</button>
		</div>
	)
}
